module.exports = __webpack_public_path__ + "static/media/1POLICY48.bbb0b108.jpg";